import { isFeatureEnabled } from '../utils'
const countryUS = isFeatureEnabled('enabledForUS'),
  countryNonUS = !countryUS
const InfoList = [
  {
    category: 'dar.section.personal.title',
    name: 'personal',
    desc: 'dar.section.personal.desc',
    infos: [
      {
        countryFeatureEnabled: countryUS,
        icon: 'contact-info',
        title: 'dar.section.personal.name.us',
        value: 'Name, Date of birth and government ID info',
        domid: 'request_name_dob_govid'
      },
      {
        countryFeatureEnabled: countryNonUS,
        icon: 'contact-info',
        title: 'dar.section.personal.name.uk',
        value: 'Name, Date of birth',
        domid: 'request_name_dob'
      },
      {
        countryFeatureEnabled: true,
        icon: 'home',
        title: 'dar.section.personal.address',
        value: 'Addresses',
        domid: 'request_addresses'
      },
      {
        countryFeatureEnabled: true,
        icon: 'email',
        title: 'dar.section.personal.email',
        value: 'Emails',
        domid: 'request_email'
      },
      {
        countryFeatureEnabled: true,
        icon: 'mobile',
        title: 'dar.section.personal.phone',
        value: 'Phone numbers',
        domid: 'request_phone'
      },
    ],
    countryFeatureEnabled: true,
  },
  {
    category: 'dar.section.financial.title',
    name: 'payment',
    desc: 'dar.section.financial.desc',
    infos: [
      {
        countryFeatureEnabled: true,
        icon: 'bank',
        title: 'dar.section.financial.bank',
        value: 'Bank Accounts',
        domid: 'request_bank'
      },
      {
        countryFeatureEnabled: true,
        icon: 'card',
        title: 'dar.section.financial.cards',
        value: 'Debit or Credit Cards',
        domid: 'request_debit_credit'
      },
    ],
    countryFeatureEnabled: true,
  },
  {
    category: 'dar.section.creditinfo.title',
    name: 'creditinfo',
    desc: 'dar.section.creditinfo.desc',
    value: 'Credit Info',
    infos: [],
    countryFeatureEnabled: countryNonUS,
    domid: 'request_credit'
  },

  {
    category: 'dar.section.usageinfo.title',
    name: 'usageinfo',
    desc: 'dar.section.usageinfo.desc',
    value: 'Usage Info',
    infos: [],
    countryFeatureEnabled: countryUS,
    domid: 'request_usageinfo'
  },
]
export default InfoList
